import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="border-b border-line bg-night px-4 py-14 sm:px-6 sm:py-20" data-id="element-194" data-mp="26yfudq03jpqc">
      <SectionHeading eyebrow="Cela vous semble familier ?" title="Reconnaissez-vous l’une de ces situations ?" subtitle="Si vous avez répondu « oui » à une seule d’entre elles… Route Maladie Rénale™ a été créée exactement pour vous." data-id="element-195" data-mp="26wlfotff4tup" />

      <ul className="mx-auto mt-10 grid w-full max-w-5xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-196" data-mp="220weklnr34wa">
        {painPoints.map(point => <li key={point.title} className="flex flex-col rounded-2xl border border-line bg-surface p-5" data-id="element-197" data-mp="1syer63wd067p">
            <span className="text-2xl" aria-hidden="true" data-id="element-198" data-mp="3iewbrov7ogfu">
              {point.emoji}
            </span>
            <h3 className="mt-3 font-display text-lg font-bold leading-snug text-white" data-id="element-199" data-mp="3nc5wwsbki5xv">
              {point.title}
            </h3>
            <p className="mt-2 text-[14px] leading-relaxed text-slate-400" data-id="element-200" data-mp="1yyc2hqu6ocs5">{point.body}</p>
          </li>)}
      </ul>

      <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-lime/25 bg-lime/[0.06] p-5 text-center sm:p-6" data-id="element-201" data-mp="27tib0xku98yd">
        <p className="text-[15px] leading-relaxed text-slate-300" data-id="element-202" data-mp="23sga8cb9woua">
          Vous n’avez pas besoin de mémoriser des centaines de pages de KDIGO. Vous avez besoin d’une
          route qui transforme les preuves en décisions cliniques.
        </p>
        <p className="mt-3 font-display text-lg font-extrabold text-lime" data-id="element-203" data-mp="1b52iqtqcglhk">
          C’est exactement ce que fait Route Maladie Rénale™.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-xl" data-id="element-204" data-mp="1k2mnwdrbv1xg">
        <CTAButton label="Je veux éliminer ces doutes aujourd’hui" caption="Accès immédiat pour seulement 19 € • Garantie de 7 jours" data-id="element-205" data-mp="30hnw5lft0zyq" />
      </div>
    </section>;
}